// 운영관리 => 설문조사 관리
import { COMMON, ifyouApi, STORY, ADMIN } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
export const surveyApis = {
  surveyList: () =>
    ifyouApi
      .get(`${ADMIN}/survey-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  surveyDetail: (survId, queId) =>
    ifyouApi
      .post(`${ADMIN}/survey-detail`, { survey_id: survId, question_id: queId })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  //등록
  surveyRegister: (inputData, answerList) =>
    ifyouApi
      .post(`${ADMIN}/survey-update`, {
        survey_id: Number(inputData.survey_id),
        question_id: Number(inputData.question_id),
        title: Number(inputData.title),
        start_date: inputData.start_date,
        end_date: inputData.end_date,
        currency: inputData.currency,
        quantity: inputData.quantity,
        is_public: inputData.is_public,
        exception_country: inputData.exception_country
          ? inputData.exception_country.toString()
          : inputData.exception_country,
        question: Number(inputData.question),
        answer_kind: inputData.answer_kind,
        select_check: inputData.select_check,
        answerList: answerList,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  //등록
  surveyUpdate: (
    record,
    inputData,
    answerList, //record는 유지사항(세부사항), inputData는 마스터데이터들
  ) =>
    ifyouApi
      .post(`${ADMIN}/survey-update`, {
        survey_id: Number(inputData.survey_id),
        question_id: Number(inputData.question_id),
        title: Number(inputData.title),
        start_date: inputData.start_date,
        end_date: inputData.end_date,
        currency: inputData.currency,
        quantity: inputData.quantity,
        is_public: inputData.is_public,
        exception_country: inputData.exception_country
          ? inputData.exception_country.toString()
          : inputData.exception_country,
        question: Number(record.question),
        answer_kind: record.answer_kind,
        select_check: record.select_check,
        answerList: answerList,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  //질문 추가할 때 애들은 따로 만들어줄게요. 항목이랑 동일한 api를 쓰는데, 필요로 하는 값이 달라서..
  questionUpdate: (masterData, inputData, answerList) =>
    ifyouApi
      .post(`${ADMIN}/survey-update`, {
        survey_id: masterData.survey_id,
        question_id: inputData.question_id, //input 등록시 0
        title: masterData.title,
        start_date: masterData.start_date,
        end_date: masterData.end_date,
        currency: masterData.currency,
        quantity: masterData.quantity,
        is_public: masterData.is_public,
        exception_country: masterData.exception_country,
        question: inputData.question, //input
        answer_kind: inputData.answer_kind, //input
        select_check: inputData.select_check, //input
        answerList: answerList,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  questionSorting: (data, rows) =>
    ifyouApi
      .post(`${ADMIN}/survey-sorting`, {
        kind: 'question',
        survey_id: data,
        question_id: data,
        rows: rows,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  answerSorting: (data, rows) =>
    ifyouApi
      .post(`${ADMIN}/survey-sorting`, {
        kind: 'answer',
        survey_id: data.survey_id,
        question_id: data.question_id,
        rows: rows,
      })
      .then((res) => res.data)

      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  surveyMasterDelete: (survId) =>
    ifyouApi
      .delete(`${ADMIN}/survey-delete-all`, {
        data: {
          survey_id: survId,
        },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  questionDelete: (survId, quesId) =>
    ifyouApi
      .delete(`${ADMIN}/survey-delete-question`, {
        data: {
          survey_id: survId,
          question_id: quesId,
        },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  answerDelete: (survId, quesId, ansId) =>
    ifyouApi
      .delete(`${ADMIN}/survey-delete-answer`, {
        data: {
          survey_id: survId,
          question_id: quesId,
          answer_id: ansId,
        },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  restrictedCountry: () =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'requestDropdownCountry',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
